import { ApiClient } from '../client/ApiClient';
import { CountryCode, getMultiTenancyHeaders } from '../utils/multiTenancyHeaders';
import { GoogleSearchClientConstructorArgs, GoogleSearchParams, GoogleSearchResponse } from './types';
import { sanitizeFilterQuotes } from '../utils/filterExpression';

export class GoogleSearchClient extends ApiClient {
  private readonly _onlineSearchApiUrl: string;
  private readonly _onlineSearchApiKey: string;
  private readonly _countryCode: CountryCode;

  constructor({ onlineSearchApiUrl, onlineSearchApiKey, countryCode }: GoogleSearchClientConstructorArgs) {
    super();
    this._onlineSearchApiUrl = onlineSearchApiUrl;
    this._onlineSearchApiKey = onlineSearchApiKey;
    this._countryCode = countryCode;
  }

  search = async (params: GoogleSearchParams): Promise<GoogleSearchResponse> => {
    const { data, error } = await this._fetch<GoogleSearchResponse>({
      path: `${this._onlineSearchApiUrl}/search`,
      method: 'POST',
      headers: {
        'x-jbg-api-key': this._onlineSearchApiKey,
        ...getMultiTenancyHeaders(this._countryCode),
      },
      body: {
        ...(params.query ? { query: params.query } : {}),
        ...(params.filter ? { filter: sanitizeFilterQuotes(params.filter) } : {}),
        ...(params.facetFilters && Object.keys(params.facetFilters).length > 0
          ? { facetFilters: params.facetFilters }
          : {}),
        ...(params.facets?.length ? { facets: params.facets } : {}),
        pageSize: params.pageSize ?? 36,
        ...(params.pageToken ? { pageToken: params.pageToken } : {}),
        ...(params.visitorId ? { visitorId: params.visitorId } : {}),
        ...(params.orderBy ? { orderBy: params.orderBy } : {}),
        ...(params.featuredProductIds?.length ? { featuredProductIds: params.featuredProductIds } : {}),
        ...(params.category ? { category: params.category } : {}),
      },
    });
    if (error || !data) throw new Error(error?.message ?? 'Google search API error');
    return data;
  };
}
